import React from 'react';
import { ViewIcon, EditIcon, DeleteIcon } from './DashboardIcons';

const mockContacts = [
    { id: 1, name: 'Carlos Sánchez', email: 'c.sanchez@example.com', phone: '+34 600 111 222', country: 'España', inquiryType: 'Multa de Velocidad', date: '2024-07-21' },
    { id: 2, name: 'Ana García', email: 'ana.g@example.com', phone: '+34 611 222 333', country: 'España', inquiryType: 'Informe Pericial', date: '2024-07-21' },
    { id: 3, name: 'John Doe', email: 'j.doe@example.com', phone: '+44 20 7946 0958', country: 'Reino Unido', inquiryType: 'Consulta General', date: '2024-07-20' },
    { id: 4, name: 'Marie Dubois', email: 'm.dubois@example.com', phone: '+33 1 23 45 67 89', country: 'Francia', inquiryType: 'Multa Aparcamiento', date: '2024-07-19' },
    { id: 5, name: 'Luigi Rossi', email: 'l.rossi@example.com', phone: '+39 06 12345678', country: 'Italia', inquiryType: 'Representación Judicial', date: '2024-07-18' },
    { id: 6, name: 'Helga Schmidt', email: 'h.schmidt@example.de', phone: '+49 30 1234567', country: 'Alemania', inquiryType: 'Multa de Velocidad', date: '2024-07-18' },
    { id: 7, name: 'Pedro Costa', email: 'p.costa@example.pt', phone: '+351 21 123 4567', country: 'Portugal', inquiryType: 'Consulta General', date: '2024-07-17' },
];

export const ContactsView: React.FC = () => {
    return (
        <div className="bg-white p-8 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Contactos Recibidos</h1>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-semibold">
                    Exportar a CSV
                </button>
            </div>
            
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3">Nombre</th>
                            <th scope="col" className="px-6 py-3">Email y Teléfono</th>
                            <th scope="col" className="px-6 py-3">País</th>
                            <th scope="col" className="px-6 py-3">Tipo de Consulta</th>
                            <th scope="col" className="px-6 py-3">Fecha</th>
                            <th scope="col" className="px-6 py-3 text-right">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mockContacts.map((contact) => (
                            <tr key={contact.id} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">{contact.name}</td>
                                <td className="px-6 py-4">
                                    <div>{contact.email}</div>
                                    <div className="text-xs text-gray-400">{contact.phone}</div>
                                </td>
                                <td className="px-6 py-4">{contact.country}</td>
                                <td className="px-6 py-4">{contact.inquiryType}</td>
                                <td className="px-6 py-4">{new Date(contact.date).toLocaleDateString()}</td>
                                <td className="px-6 py-4 text-right">
                                    <div className="flex justify-end space-x-3">
                                        <button className="text-blue-500 hover:text-blue-700" aria-label={`Ver ${contact.name}`}>
                                            <ViewIcon />
                                        </button>
                                        <button className="text-yellow-500 hover:text-yellow-700" aria-label={`Editar ${contact.name}`}>
                                            <EditIcon />
                                        </button>
                                        <button className="text-red-500 hover:text-red-700" aria-label={`Eliminar ${contact.name}`}>
                                            <DeleteIcon />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-between items-center mt-6 text-sm">
                <p className="text-gray-500">Mostrando 1 a {mockContacts.length} de {mockContacts.length} resultados</p>
                <div className="flex space-x-1">
                    <button className="px-3 py-1 border rounded-md bg-gray-100 hover:bg-gray-200">Anterior</button>
                    <button className="px-3 py-1 border rounded-md bg-blue-600 text-white">1</button>
                    <button className="px-3 py-1 border rounded-md bg-gray-100 hover:bg-gray-200">Siguiente</button>
                </div>
            </div>
        </div>
    );
};